import * as serviceContext from './serviceContext';
import { BASE_URL_M_ADMIN } from '../config';


let options = {};
let headers = new Headers();
const token = sessionStorage.getItem('token');

headers.append('content-type', 'application/json')
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';


export async function getAllModuleMaster(){
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/modulemaster`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function getModuleMasterById(moduleId){
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/modulemaster/${moduleId}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function createModuleMaster(body){
    try {
        const response = await serviceContext.post(`${BASE_URL_M_ADMIN}madmin/modulemaster`, JSON.stringify(body), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function updateModuleMaster(body){
    try {
        const response = await serviceContext.put(`${BASE_URL_M_ADMIN}madmin/modulemaster`, JSON.stringify(body), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function updateModulePosition(body){
    try {
        const response = await serviceContext.put(`${BASE_URL_M_ADMIN}madmin/modulemaster/updateposition`, JSON.stringify(body), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}